import React from 'react';
import {Backdrop, Box, Fade, Modal} from "@mui/material";
import BlueButton from "./BlueButton/BlueButton.js";
import {word} from "../word.js";
import Api from "../Api.js";
import {useNavigate, useParams} from "react-router-dom";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 600 ? 600 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: 'auto',
    overflow: 'auto',
    maxHeight: '97vh'
};
function DeleteCompany({open,setOpen}) {
    const navigate = useNavigate()
    const params = useParams()
    const {id} = params;
    const deleteCompany = async () => {
        try {
            await Api.deleteCompanies(id)
            navigate('/main_employee/organization')
            setOpen(false);

        }catch (e) {

        }
    }
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className='employee-name-cont d-flex w-100 justify-content-center'>
                        <div className="delete-company">
                            <div className="delete-company-title">{word.delete_company}</div>
                            <div className="delete-commpany-button justify-content-between">
                                <BlueButton
                                    title={word.yes}
                                    onChangeValue={deleteCompany}
                                />
                                <BlueButton
                                    title={word.no}
                                    onChangeValue={() => setOpen(false)}
                                />
                            </div>
                        </div>
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default DeleteCompany;